<template>
  <font-awesome-icon
    icon="fax"
    class="fa" />
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faFax } from '@fortawesome/free-solid-svg-icons'

library.add(faFax)

export default {
  name: 'CoozzyFaxIcon'
}
</script>

<style lang="scss" scoped>
  .fa {
    color: $color-text-grey;
  }
</style>
